import React from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';
import { Features } from 'utils/features';

const ProductboardPage = (): JSX.Element => {
  const history = useHistory();

  const user = useSelector(selectUser);

  if (
    user &&
    !(user.hasPrivilege(Privileges.PRODUCTBOARD_VIEW) && user.hasFeature(Features.PRODUCTBOARD))
  ) {
    history.replace('/');
  }

  return (
    <>
      <Helmet title="Feedback" />
      <div
        style={{
          margin: '-50px -50px 0 -50px',
          height: 'calc(100vh - 100px)',
        }}
      >
        <iframe
          title="Productboard"
          src="https://portal.productboard.com/nfzoqrdl8dz9gwtov9rfb2y4?hide_logo=1"
          style={{
            width: '100%',
            height: 'calc(100vh - 100px)',
            border: 0,
          }}
        ></iframe>
      </div>
    </>
  );
};

export default ProductboardPage;
